import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/account/auth.service';
import { GlobalService } from '../services/global.service';
import { IdentityService } from '../services/identity.service';
import { ViewportScroller } from '@angular/common';

@Component({
    selector: 'app-loading-spinner',
    templateUrl: './loading-spinner.component.html',
    styleUrls: ['./loading-spinner.component.scss'],
    standalone: false
})
export class LoadingSpinnerComponent implements OnInit {
  DontShow: boolean = true;
  constructor(public globalService: GlobalService, private identityService: IdentityService, private _router: Router,private authService: AuthService,
    private viewportScroller: ViewportScroller
  ) {}

  ngOnInit(): void {
    document.getElementsByTagName('body')[0].style.minHeight = window.localStorage.getItem('bodyHeight'); 
    // this.viewportScroller.scrollToPosition([0, 0]);
    this.DontShow = false;
    // this.viewportScroller.scrollToPosition([0, 0]);
  } 
  
  GoHome(){ 
    this.identityService.authenticated = false;
    this.identityService.permissions = [];
    this.authService.logout(1);
    this._router.navigate([this.globalService.subdomain + '/login']);
  }   
}
           